export default __webpack_public_path__ + "static/media/join button.56b7808f.svg";